import { Component } from '@angular/core';
import {
  AbstractMultipleAutocompleteCellEditComponent
} from '@app/shared/components/cell-edit/multiple-autocomplete-cell-edit/abstract-multiple-autocomplete-cell-edit/abstract-multiple-autocomplete-cell-edit.component';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'multiple-autocomplete-cell-text-cell-edit',
  templateUrl: './abstract-multiple-autocomplete-cell-edit/abstract-multiple-autocomplete-cell-edit.component.html',
  styleUrls: ['./abstract-multiple-autocomplete-cell-edit/abstract-multiple-autocomplete-cell-edit.component.scss'],
  standalone: false
})
export class MultipleEntityAutocompleteCellEditComponent extends AbstractMultipleAutocompleteCellEditComponent<ChipInput> {

  public getFieldValue(value: ChipInput): string {
    return value.entityName;
  }

  public getValue(): ChipInput[] {
    return this.chips.length > 0 ? this.chips : undefined;
  }

  public newInput(entity: ChipInput): void {
    if (!this.control.valid) return;
    if ((entity.entityName == '-')) {
      // remove all entities
      this.chips = [];
    } else if ((entity.entityName || '').trim()) {
      // Add the new chip
      this.chips.push(entity);
      this.setFilterSuggestions();
    }
    this.adjustColumnWidth();
    this.control.setValue('');

  }

  protected filter(value: string): ChipInput[] {
    const filterValue = value.toLowerCase();
    return this.suggestedOptions.filter(entity => {
      return entity.entityName.toLowerCase().includes(filterValue) && !this.chips.includes(entity);
    });
  }

  public sortSuggestedOption(): void {
    this.suggestedOptions.sort((entityA, entityB) => entityA.entityName.compareTo(entityB.entityName));
  }

  public setFilterSuggestions(): void {
    this.filteredSuggestions = this.control.valueChanges
      .pipe(
        startWith(''),
        map((value) => {
          // We cannot do equality check on two objects, so we compare the ids
          const entityIds = this.chips.map(it => it.entityId);
          return typeof value === 'string' && value.trim() ? this.filter(value) : this.suggestedOptions.filter(entity => {
            return !entityIds.includes(entity.entityId);
          });
        })
      );
  }

  public onEnter(_: KeyboardEvent): void {
    //do nothing
  }
}

export interface ChipInput {
  entityName: string;
  entityId: string;
}
